



















































































































































































































































































































































































































































































































































































import {
  Vue,
  photosUrlEnum,
  headers,
  servicesURL,
  analyticsEvents,
  getCookie,
  cookies,
} from "../../constants/constants";
import {
  validateRestaurantMinOrderValue,
  updatePhotosURL,
  pushAnalyticsEvent,
} from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import { BasketLoadersEnum } from "../../models/basket.model";
import * as moment from "moment";
import axios from "axios";

var modalOpened = false;
export default Vue.component("current-order-details", {
  data() {
    return {
      staticContent,
      photosUrlEnum,
      basketLoader: BasketLoadersEnum,
      trackingStates: ["Placed", "Preparing", "On it's way", "Delivered"],
      driver: "",
      lang: getCookie(cookies.lang) == "AR" ? "ar-ly" : "en",
      canShowPin: false,
      driverStates: [],
      tripStatus: "",
    };
  },
  props: {
    Track: Boolean,
  },
  mounted() {
    this.$root.isRTL
      ? (this.trackingStates = [
          `في إنتظار رد المطعم`,
          `الأوردر بيتحضر`,
          `الأوردر خرج في الطريق`,
          `الأوردر وصل`,
        ])
      : (this.trackingStates = [
          "Placed",
          "Preparing",
          "On it's way",
          "Delivered",
        ]);
    this.startTracking();
    this.setupDriverStatus();
  },
  updated() {
    if (
      !this.driver &&
      (this.driverStates.includes(this.tripStatus) || this.selectedOrder.data.orderStateEnum == "OUT_FOR_DELIVERY") &&
      this.selectedOrder.ref.tripUUID
    ) {
      this.getDriverData(this.selectedOrder.ref.tripUUID);
    }
  },
  computed: {
    URLBuilder() {
      return this.$root.URLBuilder;
    },
    isRTL() {
      return this.$root.isRTL;
    },
    userCityName() {
      return this.$root.userCityName;
    },
    moment() {
      return moment;
    },
    isOnItsWay() {
      return this.selectedOrder.data.orderStateEnum == "OUT_FOR_DELIVERY";
    },
    isPreparing() {
      return this.selectedOrder.data.orderStateEnum == "ACCEPTED";
    },
    isDelivered() {
      return this.selectedOrder.data.orderStateEnum == "DELIVERED";
    },
    isCanceled() {
      return this.selectedOrder.data.orderStateEnum == "CANCELED";
    },
    isRejected() {
      return this.selectedOrder.data.orderStateEnum == "REJECTED";
    },
    selectedOrderState() {
      return this.$store.state.selectedOrder.data.orderStateEnum;
    },
    selectedOrderActionType() {
      return this.$store.state.selectedOrder.data.actionType;
    },
    myOrdersPageLoader() {
      return this.$store.state.myOrdersPageLoader;
    },
    OrderType() {
      return this.$store.state.selectedOrderType;
    },
    selectedOrder() {
      return this.$store.state.selectedOrder;
    },
    isMyOrderDelivered() {
      return this.$root.isMyOrderDelivered;
    },
    orderStatus() {
      return this.$root.orderStatus;
    },
    cancelCurrentOrder() {
      return this.$root.cancelCurrentOrder;
    },
    currentOrders() {
      return this.$store.state.currentOrders.data;
    },
    profile() {
      return this.$store.getters.getProfileData;
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    hasCancelBtn() {
      let cancelFlag = this.$root.getRemoteConfigByKey('Cancel_Button_Web')
      return cancelFlag == 'true';
    },
    cancelMessage() {
      return this.$root.getTextFromRemoteConfig('Cancel_Order_Message_Description_Web')
    },
    driverStateConfig() {
      return this.$root.getRemoteConfigByKey('WEB_SHOW_DRIVER_DETAILS');
    },
  },
  methods: {
    startTracking() {
      this.getSelectedOrderStateDetails();
      this.$root.user.orderTracking = setInterval(() => {
        this.getSelectedOrderStateDetails();
      }, 1000 * 30); // get status after each 20 sec
    },
    stopTracking() {
      clearInterval(this.$root.user.orderTracking);
    },

    getSelectedOrderStateDetails() {
      this.$store
        .dispatch("GET_SPECIFIC_ORDER_STATUS")
        .then((res) => {
          this.tripStatus = res.data.tripStatus;
          if (res.data.state == "CANCELED") {
            this.stopTracking();
            this.$root.cancelCurrentOrder = false;
            this.$root.resumeOrder.uuid == this.selectedOrder.orderUUID &&
              (this.$root.resumeOrder.cancelLoading = false);
          } else if (
            res.data.state == "DELIVERED" ||
            res.data.state == "REJECTED"
          ) {
            this.stopTracking();
          }
          (this.driverStates.includes(res.data.tripStatus) || res.data.state == "OUT_FOR_DELIVERY") &&
            res.data.tripUUID &&
            this.getDriverData(res.data.tripUUID);

          res.data.state !== "INSPECTING" &&
            this.modalToggler("resume-order-modal", "hide");

          let rejectionReasons = [
            "REJECTED_ADDRESS_NOT_CLEAR",
            "REJECTED_INSUFFICIENT_FUNDS",
          ];
          if (
            rejectionReasons.indexOf(
              this.$store.state.selectedOrder.data.actionType
            ) > -1 &&
            this.selectedOrderState == "INSPECTING" &&
            this.bindConditionalClasses.indexOf("resume-order-modal") <= -1
          ) {
            this.$root.resumeOrder.uuid = this.selectedOrder.orderUUID;
            this.$root.resumeOrder.reason =
              this.$store.state.selectedOrder.data.actionType;
            if (this.selectedOrder.ref.userUUID == this.profile.uuid) {
              this.$root.resumeOrder.ref = this.selectedOrder.ref;
              this.$root.resumeOrder.data = this.selectedOrder.data;
              this.modalToggler("resume-order-modal", "show");
            }
          }
          if (
            !this.selectedOrder.data.fleet &&
            (this.isPreparing || this.isOnItsWay) &&
            moment().diff(
              moment(this.selectedOrder.data.acceptedAt),
              "minutes"
            ) > this.selectedOrder.data.estimatedDeliveryTime
          ) {
            this.$store.commit("updateSelectedOrderStatus", "DELIVERED");
            this.stopTracking();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    modalToggler(modalId, action) {
      this.$root.modalToggler(modalId, action);
    },
    backToList() {
      document
        .getElementById("orders-controller")
        .classList.remove("my-orders-mobile");
      document
        .getElementById("orders-details")
        .classList.add("my-orders-mobile");
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
    basketLoadersEnum() {
      return this.$root.basketLoadersEnum;
    },
    openChatWindow(orderUUID) {
      this.$root.openChatWindow(orderUUID);
    },
    getURL(url) {
      return this.$root.updatePhotosURL(
        url,
        this.$root.photosUrlEnum.version.thumbnail
      );
    },
    dateFromNow(date) {
      return this.$root.dateFromNow(date);
    },
    formatAMPM(date) {
      return this.$root.formatAMPM(date);
    },
    selectOrderToCancel(orderUUID) {
      this.$root.selectOrderToCancel(orderUUID);
    },
    getDriverData(tripUUID) {
      this.$store
        .dispatch("GET_DRIVER_LOCATION", tripUUID)
        .then((res) => {
          res.data.photo =
            "https://s3-eu-west-1.amazonaws.com/elmenusv5/Thumbnail/" +
            res.data.driverPhoto +
            ".jpg";
          this.driver = res.data;
          // Mixpanel
          pushAnalyticsEvent(
            analyticsEvents.myOrders.category,
            analyticsEvents.myOrders.events.callDriver,
            analyticsEvents.myOrders.labels.trip(
              res.data.driverName,
              res.data.tripStatus
            )
          );
          return res.data;
        })
        .catch((error) => console.log(error));
    },
    setupDriverStatus() {
      const driverStateConfig = this.$root.getRemoteConfigByKey('WEB_SHOW_DRIVER_DETAILS');
      this.canShowPin = this.$root.getRemoteConfigByKey('WEB_SHOW_DRIVER_PIN') == 'true';
      const orderStates = ["CANCELED", "PENDING", "DISPATCHED", "ACCEPTED", "READY_FOR_PICKUP", "OUT_FOR_DELIVERY", "ARRIVED", "DELIVERED"];
      const stateIndex = orderStates.findIndex(state => state === driverStateConfig);
      if(stateIndex == -1) {
        this.driverStates = orderStates.slice(orderStates.findIndex(state => state === "OUT_FOR_DELIVERY"));
      } else {
        this.driverStates = orderStates.slice(stateIndex);
      }
    },
  },
});
